export default class OversizeHeadline extends ContaoWebpack.Plugin {
	init () {
        this.options = {...{
            fontSize: null,
            textIndent: null,
        }, ...this.options}

        this.target = this.el.querySelector('.tz-container-type-inline-size h3');

        if (this.options.fontSize) {
            this.target.style.fontSize = this.options.fontSize;
        }
        if (this.options.textIndent) {
            this.target.style.textIndent = this.options.textIndent;
        }
    }
}
